import Vue from 'vue'
import Vuex from 'vuex'
import vuexAlong from 'vuex-along'
// import home from './home'
// import kind from './kind'
 import cart from './cart'
// import login from './login'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    // home,
    // kind,
     cart,
    // login
  }
  ,
  plugins: [vuexAlong({
    name: 'hello-vuex-along', // 设置保存的集合名字，避免同站点下的多项目数据冲突
    local: {
      list: [ 'cart']
      // isFilter: true  过滤模块 ma 数据， 将其他的存入 localStorage
    },
    justSession: true, // 只存储sesstionstroge
    session: {
      list: ['cart'] // 保存 count 和模块 ma 中的 a1 到 sessionStorage
    }
  })]

})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js